import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logos/TSV-Logo.webp";
import SubscribeBanner from "../Home/SubscribeBanner";

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  // Helper to scroll smoothly to a section
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Footer navigation handler
  const handleFooterNavClick = (item) => {
    if (item.href === "#news") {
      // Scroll to news section on home
      if (window.location.pathname !== "/") {
        navigate("/");
        setTimeout(() => scrollToSection("news"), 400);
      } else {
        scrollToSection("news");
      }
    } else {
      // Navigate to normal route
      navigate(item.link);
    }
  };

  return (
    <React.Fragment>
      <SubscribeBanner />

      <footer className="w-full bg-[#00150D] text-gray-300 relative overflow-hidden tracking-wide">
        {/* Background Gradient */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0 bg-gradient-to-br from-[#006147] to-[#FF7F40]" />
        </div>

        {/* Main Content */}
        <div className="relative z-10 px-4 sm:px-6 lg:px-12">
          {/* Top Section */}
          <div className="py-8 border-b border-gray-700 border-opacity-30">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
              {/* Brand */}
              <div className="text-center lg:text-left">
                <div
                  className="flex items-center cursor-pointer mb-3"
                  onClick={() => navigate("/")}
                >
                  <img
                    src={logo}
                    alt="Techspear Logo"
                    className="h-12 md:h-16 w-auto transition-transform duration-300 hover:scale-105"
                  />
                </div>
                <p className="text-gray-400 text-md max-w-md">
                  Empowering your financial journey with innovative solutions
                  and trusted expertise.
                </p>
              </div>

              {/* Navigation Links */}
              <div className="flex flex-wrap justify-center gap-6">
                {[
                  { label: "Portfolio", link: "/portfolio" },
                  { label: "Procure Funds", link: "/procure-funds" },
                  { label: "About", link: "/about" },
                  { label: "News", link: "/" },
                  { label: "Contact", link: "/contact" },
                ].map((item) => (
                  <button
                    key={item.label}
                    onClick={() => handleFooterNavClick(item)}
                    className="group relative text-gray-300 text-sm hover:text-white transition-all duration-300 font-normal tracking-wide"
                  >
                    {item.label}
                    {/* <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-[#006147] to-[#FF7F40] group-hover:w-full transition-all duration-300"></span> */}
                  </button>
                ))}
              </div>

              {/* Contact Info */}
              <div className="text-center lg:text-right">
                <div className="mb-4">
                  <p className="text-lg font-normal text-white bg-gradient-to-r from-[#006147] to-[#FF7F40] bg-clip-text text-transparent">
                    Info@techspearventures.com
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="py-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              {/* Copyright */}
              <div className="text-center md:text-left">
                <p className="text-sm text-gray-400">
                  © Techspear Ventures. {currentYear}. All Rights Reserved.
                </p>
              </div>

              {/* Legal Links */}
              <div className="flex items-center space-x-6 text-sm">
                <div
                  onClick={() => navigate("/privacy-policy")}
                  className="cursor-pointer text-gray-400 hover:text-white transition-colors duration-300 hover:underline"
                >
                  Privacy Policy
                </div>
                <div className="w-1 h-1 bg-gray-600 rounded-full" />
                <div
                  onClick={() => navigate("/terms-condition")}
                  className="cursor-pointer text-gray-400 hover:text-white transition-colors duration-300 hover:underline"
                >
                  Terms & Conditions
                </div>
                <div className="w-1 h-1 bg-gray-600 rounded-full" />
                <div
                  onClick={() => navigate("/cookies-policy")}
                  className="cursor-pointer text-gray-400 hover:text-white transition-colors duration-300 hover:underline"
                >
                  Cookie Policy
                </div>
              </div>

              {/* Back to Top */}
              <button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors duration-300 group"
              >
                <span className="text-sm">Back to Top</span>
                <div className="w-8 h-8 rounded-full border border-gray-600 flex items-center justify-center group-hover:border-[#006147] group-hover:bg-[#006147] transition-all duration-300">
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 15l7-7 7 7"
                    />
                  </svg>
                </div>
              </button>
            </div>
          </div>
        </div>

        {/* Decorative Line */}
        <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-[#006147] via-[#FF7F40] to-[#006147]" />
      </footer>
    </React.Fragment>
  );
};

export default Footer;

// import React from "react";

// const Footer = () => {
//   return (
//     <footer className="w-full bg-primaryBgColor text-gray-400 py-10">
//       {/* Main Footer Section */}
//       <div className="flex flex-col md:flex-row items-center justify-between gap-4 px-4 sm:px-6 lg:px-12">
//         {/* Left Side - Email */}
//         <div className="text-base md:text-lg font-semibold tracking-wider">
//           Info@techspearventures.com
//         </div>

//         {/* Center - Navigation */}
//         <div className="flex flex-wrap justify-center gap-6 text-sm md:text-base tracking-wider">
//           <a
//             href="#portfolio"
//             className="hover:text-primaryBtnHoverColor transition"
//           >
//             Portfolio
//           </a>
//           <a
//             href="#engage"
//             className="hover:text-primaryBtnHoverColor transition"
//           >
//             Engage
//           </a>
//           <a
//             href="#about"
//             className="hover:text-primaryBtnHoverColor transition"
//           >
//             About
//           </a>
//           <a
//             href="#news"
//             className="hover:text-primaryBtnHoverColor transition"
//           >
//             News
//           </a>
//           <a
//             href="#contact"
//             className="hover:text-primaryBtnHoverColor transition"
//           >
//             Contact
//           </a>
//         </div>
//       </div>

//       {/* Outlined Text Section */}
//       <div className="mt-10 text-center overflow-hidden">
//         <h1
//           className="font-extrabold tracking-wider text-[10vw] md:text-[10vw] py-4 text-transparent leading-none"
//           style={{
//             WebkitTextStroke: "1px #99aabb", // Outline effect
//             whiteSpace: "nowrap",
//           }}
//         >
//           techspear ventures
//         </h1>
//       </div>

//       <div className="mt-10 tracking-wider flex flex-col md:flex-row items-center justify-between gap-4 px-4 sm:px-6 lg:px-12">
//         {/* Bottom - Copyright */}
//         <div className="mt-4 text-center text-xs md:text-sm text-gray-400">
//           © Techspear Ventures. 2025. All Rights Reserved.
//         </div>

//         {/* Right Side - Privacy */}
//         <div className="text-xs md:text-sm text-gray-400 text-center">
//           Privacy Policy <span className="mx-1">.</span> Terms & Conditions
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
